'use strict';

var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cdnService = exports.CdnService = exports.getImagePath = exports.imageTypeToPath = exports.ImageType = exports.ImageCrop = exports.ImageFormat = exports.ImageAuto = exports.ImageFit = void 0;
/**
 * https://docs.imgix.com/apis/url/size/fit
 */
var ImageFit;
(function (ImageFit) {
    ImageFit["CLAMP"] = "clamp";
    ImageFit["CLIP"] = "clip";
    ImageFit["CROP"] = "crop";
    ImageFit["FACEAREA"] = "facearea";
    ImageFit["FILL"] = "fill";
    ImageFit["FILLMAX"] = "fillmax";
    ImageFit["MAX"] = "max";
    ImageFit["MIN"] = "min";
    ImageFit["SCALE"] = "scale";
})(ImageFit = exports.ImageFit || (exports.ImageFit = {}));
var ImageAuto;
(function (ImageAuto) {
    ImageAuto["FORMAT"] = "format";
    ImageAuto["COMPRESS"] = "compress";
    ImageAuto["FORMAT_AND_COMPRESS"] = "format,compress";
})(ImageAuto = exports.ImageAuto || (exports.ImageAuto = {}));
var ImageFormat;
(function (ImageFormat) {
    ImageFormat["PNG"] = "png";
    ImageFormat["JPG"] = "jpg";
    ImageFormat["WEBP"] = "webp";
    ImageFormat["PJPG"] = "pjpg";
    ImageFormat["JSON"] = "json";
    ImageFormat["AVIF"] = "avif";
    ImageFormat["SVG"] = "svg";
})(ImageFormat = exports.ImageFormat || (exports.ImageFormat = {}));
var ImageCrop;
(function (ImageCrop) {
    ImageCrop["TOP"] = "top";
    ImageCrop["BOTTOM"] = "bottom";
    ImageCrop["LEFT"] = "left";
    ImageCrop["RIGHT"] = "right";
    ImageCrop["FACES"] = "faces";
    ImageCrop["FOCAL_POINT"] = "focalpoint";
    ImageCrop["EDGES"] = "edges";
    ImageCrop["ENTROPY"] = "entropy";
})(ImageCrop = exports.ImageCrop || (exports.ImageCrop = {}));
var ImageType;
(function (ImageType) {
    ImageType["GAME_THUMBNAIL"] = "game-thumbnail";
    ImageType["GAME_BACKGROUND"] = "game-background";
    ImageType["GAME_TOKEN"] = "game-token";
    ImageType["GAME_TOKEN_HISTORY"] = "game-token-history";
    ImageType["GAME_LOGO_SMALL"] = "game-logo-small";
    ImageType["GAME_LOGO_LARGE"] = "game-logo-large";
    ImageType["GAME_DETAIL_BACKGROUND_PORTRAIT"] = "game-detail-background-portrait";
    ImageType["GAME_DETAIL_BACKGROUND_LANDSCAPE"] = "game-detail-background-landscape";
    ImageType["GAME_DETAIL_LOGO"] = "game-detail-logo";
    ImageType["CATEGORY_BACKGROUND"] = "category-background";
    ImageType["CATEGORY_THUMBNAIL"] = "category-thumbnail";
    ImageType["OFFER_IMAGES"] = "offer-images";
    ImageType["OFFER_BACKGROUND"] = "offer-background";
    ImageType["REWARD_IMAGES"] = "reward-images";
    ImageType["REWARD_ICONS"] = "reward-icons";
    ImageType["PAGE_IMAGES"] = "page-images";
    ImageType["PAGE_BACKGROUND"] = "page-background";
    ImageType["PROMO_LOBBY"] = "promo-lobby";
    ImageType["PROMO_MOBILE_BACKGROUND"] = "promo-mobile-background";
    ImageType["PROMO_IMAGES"] = "promo-images";
    ImageType["TEASER_IMAGE"] = "teaser-image";
    ImageType["OMS_IMAGE"] = "oms-image";
    ImageType["CALENDAR_BACKGROUNDS"] = "calendar-backgrounds";
    ImageType["BONUSES_IMAGES"] = "bonuses-images";
    ImageType["LOTTERY_BACKGROUND"] = "lottery-background";
    ImageType["LOTTERY_LOGOS"] = "lottery-logos";
    ImageType["CASHIER_LOGO"] = "cashier-logo";
})(ImageType = exports.ImageType || (exports.ImageType = {}));
exports.imageTypeToPath = (_a = {},
    _a[ImageType.GAME_THUMBNAIL] = 'games/thumbs',
    _a[ImageType.GAME_BACKGROUND] = 'games/bgs',
    _a[ImageType.GAME_TOKEN] = 'games/token/main',
    _a[ImageType.GAME_TOKEN_HISTORY] = 'games/token/history',
    _a[ImageType.GAME_LOGO_SMALL] = 'games/logos/sm',
    _a[ImageType.GAME_LOGO_LARGE] = 'games/logos/lg',
    _a[ImageType.GAME_DETAIL_BACKGROUND_PORTRAIT] = 'games/detail/portrait/bgs',
    _a[ImageType.GAME_DETAIL_BACKGROUND_LANDSCAPE] = 'games/detail/landscape/bgs',
    _a[ImageType.GAME_DETAIL_LOGO] = 'games/detail/logo',
    _a[ImageType.CATEGORY_BACKGROUND] = 'categories/bgs',
    _a[ImageType.CATEGORY_THUMBNAIL] = 'categories/thumbs',
    _a[ImageType.OFFER_IMAGES] = 'offers/img',
    _a[ImageType.OFFER_BACKGROUND] = 'offers/bgs/lg',
    _a[ImageType.REWARD_IMAGES] = 'rewards/img',
    _a[ImageType.REWARD_ICONS] = 'rewards/icon',
    _a[ImageType.PAGE_IMAGES] = 'pages/img',
    _a[ImageType.PAGE_BACKGROUND] = 'pages/bgs/lg',
    _a[ImageType.PROMO_LOBBY] = 'promos/src',
    _a[ImageType.PROMO_MOBILE_BACKGROUND] = 'promos/mobile',
    _a[ImageType.PROMO_IMAGES] = 'promos/img',
    _a[ImageType.TEASER_IMAGE] = 'teasers',
    _a[ImageType.OMS_IMAGE] = 'oms',
    _a[ImageType.CALENDAR_BACKGROUNDS] = 'calendars/bgs/lg',
    _a[ImageType.BONUSES_IMAGES] = 'bonuses/img',
    _a[ImageType.LOTTERY_BACKGROUND] = 'lottery/bgs/lg',
    _a[ImageType.LOTTERY_LOGOS] = 'lottery/img',
    _a[ImageType.CASHIER_LOGO] = 'cashier/logo',
    _a);
/**
 * Get CDN image path from the image type provided.
 * @param type The type of the image
 */
function getImagePath(type, imageName) {
    return "" + exports.imageTypeToPath[type] + (imageName ? "/" + imageName : '');
}
exports.getImagePath = getImagePath;
/**
 * The CDN Service provides methods relating to fetching
 * static assets from the CDN.
 */
var CdnService = /** @class */ (function () {
    function CdnService() {
    }
    CdnService.prototype.setup = function (imgCdnUrl) {
        this.imgCdnUrl = imgCdnUrl;
    };
    /**
     * Prepends the CDN URL for image
     * assets and returns it.
     * @param imagePath The path to the image without the CDN url
     * @param [params] - Image conversion params
     * @returns The full URL to the image.
     */
    CdnService.prototype.getImageUrl = function (imagePath, params) {
        var url = this.imgCdnUrl + "/" + imagePath.replace(/^(\/+)/, '');
        if (params && Object.keys(params).length) {
            url += "?" + this.mapImgParams(params);
        }
        return url;
    };
    CdnService.prototype.getPageImageUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PAGE_IMAGES, imagePath), params);
    };
    CdnService.prototype.getOfferImageUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.OFFER_IMAGES, imagePath), params);
    };
    CdnService.prototype.getPromotionImageUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PROMO_IMAGES, imagePath), params);
    };
    CdnService.prototype.getPageBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PAGE_BACKGROUND, imagePath), params);
    };
    CdnService.prototype.getOfferBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.OFFER_BACKGROUND, imagePath), params);
    };
    CdnService.prototype.getPromotionBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PROMO_LOBBY, imagePath), params);
    };
    CdnService.prototype.getLandingMobileBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PROMO_MOBILE_BACKGROUND, imagePath), params);
    };
    CdnService.prototype.getLandingBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PROMO_LOBBY, imagePath), params);
    };
    CdnService.prototype.getPromotionMobileBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.PROMO_MOBILE_BACKGROUND, imagePath), params);
    };
    CdnService.prototype.getThumbnailUrl = function (gameId, params) {
        return this.getImageUrl(getImagePath(ImageType.GAME_THUMBNAIL, gameId + ".jpg"), params);
    };
    CdnService.prototype.getRewardsImageUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.REWARD_IMAGES, imagePath), params);
    };
    CdnService.prototype.getRewardsIconUrl = function (iconPath, params) {
        return this.getImageUrl(getImagePath(ImageType.REWARD_ICONS, iconPath), params);
    };
    CdnService.prototype.getLotteryLogoUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.LOTTERY_LOGOS, imagePath), params);
    };
    CdnService.prototype.getLotteryBackgroundUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.LOTTERY_BACKGROUND, imagePath), params);
    };
    CdnService.prototype.getOmsImageUrl = function (imagePath, params) {
        return this.getImageUrl(getImagePath(ImageType.OMS_IMAGE, imagePath), params);
    };
    CdnService.prototype.getOmsVideoUrl = function (videoPath, params) {
        var url = this.imgCdnUrl + "/oms/video/" + videoPath.replace(/^(\/+)/, '');
        if (params && Object.keys(params).length) {
            url += "?" + this.mapVideoParams(params);
        }
        return url;
    };
    /**
     * Maps the image parameters to Imgix parameters
     */
    CdnService.prototype.mapImgParams = function (params) {
        var _a;
        var mappedParams = (_a = {
                w: this.round(params.width),
                h: this.round(params.height),
                q: params.quality,
                dpr: params.retina === true ? 2 : undefined,
                fit: params.fit,
                crop: params.crop,
                auto: params.auto,
                bg: params.bg,
                lossless: params.lossless,
                fm: params.format
            },
            _a['min-w'] = this.round(params.minWidth),
            _a['min-h'] = this.round(params.minHeight),
            _a);
        // Add fallback format for safari webp.
        if (mappedParams.auto === ImageAuto.FORMAT && !mappedParams.fm) {
            mappedParams.fm = ImageFormat.JPG;
        }
        return Object.entries(mappedParams)
            .filter(function (_a) {
            var val = _a[1];
            return val !== undefined;
        })
            .map(function (_a) {
            var key = _a[0], val = _a[1];
            return encodeURIComponent(key) +
                '=' +
                encodeURIComponent(val);
        })
            .join('&');
    };
    CdnService.prototype.mapVideoParams = function (params) {
        return Object.entries(params)
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return encodeURIComponent(key) + "=" + encodeURIComponent(value);
        })
            .join('&');
    };
    CdnService.prototype.round = function (num) {
        if (num === 'auto') {
            return num;
        }
        return num ? Math.round(num) : num;
    };
    return CdnService;
}());
exports.CdnService = CdnService;
exports.cdnService = new CdnService();
